import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TiktokIcon,
  TwitterIcon,
} from '@/components/icons/common'

import { Container } from './container'

export function SiteFooterAuth() {
  return (
    <Container className="py-6 md:py-12">
      <footer className="text-black md:mx-auto md:max-w-screen-lg">
        <div className="flex flex-col justify-between gap-y-6 md:flex-row">
          <div className="grid grid-cols-2 gap-y-6 md:w-3/4 md:grid-cols-3 md:gap-12">
            <div>
              <img src="/YES-logo.png" alt="logo" width={120} height={65} />
            </div>
            <div className="hidden">
              <h4 className="font-semibold">Perusahaan</h4>
              <div className="mt-2 font-light md:mt-4">
                <div>About Us</div>
                <div>Terms & Conditions</div>
              </div>
            </div>
            <div>
              <h4 className="font-semibold">Kontak Kami:</h4>
              <div className="mt-2 font-light">
                <div>Email: halo@yes.co.id</div>
                <div>Telepon: +62 811 811 628</div>
              </div>
            </div>
          </div>
          <div className="flex gap-6">
            {/* <FacebookIcon /> */}
            {/* <TwitterIcon /> */}
            <InstagramIcon
              onClick={() =>
                window.open(
                  'https://instagram.com/@yes.co.id_official',
                  '_black'
                )
              }
            />
            <TiktokIcon
              onClick={() =>
                window.open('https://www.tiktok.com/@yes.co.id', '_black')
              }
            />
            {/* <LinkedInIcon /> */}
          </div>
        </div>
      </footer>
    </Container>
  )
}

export function SiteFooterUser() {
  return (
    <footer className="flex items-center justify-center bg-[#2C2C2C] py-12">
      <p className="text-white">Copyright © 2025. All rights reserved.</p>
    </footer>
  )
}
